import { LoaderSpinner } from "@/components/PartsViewer/v2/icon.js"
import styles from "@/components/Loader/index.module.scss"
const Loader = () => {
  return (
    <div className={styles.LoaderComponent}>
      <div className="loader-image">
        <LoaderSpinner />
      </div>
    </div>
  )
}
export default Loader
